export default __webpack_public_path__ + "static/media/Weather-Dashboard.0973d3c5.png";